<template>
  <form v-on:submit.prevent="submit">
    <label for="nl_email" class="sr-only">E-Mail Adresse</label>
    <input
      :class="[{validable:validable, loading:loading, success:success, error:error}]"
      v-model="email"
      v-on:keyup="validable = $event.target.value !== '';"
      required
      type="email"
      id="nl_email"
      title="E-Mail Adresse"
      placeholder="E-Mail eingeben"
    ><input type="submit" value=" " aria-label="Abschicken">
  </form>
</template>


<script>
export default {
  props: ['setEmail', 'action'],
  data() {
    return {
      email: this.setEmail?this.setEmail:'',
      validable: false,
      loading: false,
      error: false,
      success: false
    };
  },
  methods: {
    submit: function() {
      let vm = this;
      if (!this.loading) {
        vm.loading = true;
        var action = vm.action || 'subscribe';
        this.$http
          .post("/newsletter/"+action, "email=" + vm.email, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
          })
          .then(response => {
            (vm.loading = false),
              (vm.error = false),
              (vm.success = true),
              (vm.validable = false);

            if(vm.action=='unsubscribe'){
              vm.$event.$emit('alert', {eventName:'success', text:'E-Mail '+vm.email+' wurde abgemeldet.'});
              vm.$event.$emit('userinteraction', {item:'input newsletter unsubscribe', from:vm.$route.path});
            } else {
              vm.$event.$emit('alert', {eventName:'success', text:'Vielen Dank für Ihre Anmeldung.<br />Wir haben Ihnen eine E-Mail zugeschickt. Bitte bestätigen Sie darin den Link, um Ihre Anmeldung abzuschließen.'});
              vm.$event.$emit('userinteraction', {item:'input newsletter subscribe', from:vm.$route.path});
            }
            vm.email = "";
            setTimeout(function() {
              (vm.loading = false), (vm.error = false), (vm.success = false);
            }, 2000);
          })
          .catch(response => {
            (vm.loading = false),
              (vm.error = true),
              (vm.success = false),
              (vm.validable = false);
            setTimeout(function() {
              (vm.loading = false), (vm.error = false), (vm.success = false);
            }, 1000);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";

form {
  text-align: center;
}
input {
  background-color: transparent;
  color: white;
  border: 2px solid $red-fill;
  padding: 5%;
  font-size: 1em;
  width: 75%;
  box-sizing: border-box;
  border-radius: 0;
  & + input {
    transition: background-image 0.3s ease;
  }

  &::placeholder {
    color: white;
  }
  @include for-size(big-desktop-up) {
    font-size: 1.1vw;
  }
  &:hover + input {
  }
  &.validable:invalid {
    & + input {
      background-image: url(/static/img/close.svg);
      background-size: 40% !important;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        background-image: url(/static/img/check.svg);
      }
    }
  }
  &.loading + input {
    background-image: url(/static/img/loading.svg);
    &:hover {
      background-position: center !important;
    }
  }

  &.error {
    animation: 0.5s shake ease;
    & + input {
      animation: 0.5s shake ease;
    }
  }
  &.success + input {
    background-image: url(/static/img/check.svg) !important;
    &:hover {
      background-position: center !important;
    }
  }

}
input[type="submit"] {
  background-color: $red-fill;
  width: 25%;
  background-image: url(/static/img/Arrow.svg);
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  transition: all 0.5s ease;
  &:hover {
    background-position: 70% center;
  }
}

@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/NewsletterInput.vue